import React, { useEffect, useState } from 'react';
import Layout from '../components/Layout';
import axios from '../axios';

const UserManagement = () => {
  const [users, setUsers] = useState([]);
  const [formData, setFormData] = useState({ name: '', username: '', password: '', type :'employee', permission :'view' });
  const [editId, setEditId] = useState(null);
   

  useEffect(() => {
    fetchUsers();
  }, []);

  const fetchUsers = async () => {
    const res = await axios.get('/users');
    setUsers(res.data);
  };

  const handleChange = (e) => {
    setFormData(prev => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (editId) {
      await axios.put(`/users/${editId}`, formData);
    } else {
      await axios.post('/users', formData);
    }
    setFormData({ name: '', username: '', password: '' , permission : 'view'});
    setEditId(null);
    fetchUsers();
  };

  const handleEdit = (user) => {
    setFormData({ name: user.name, username: user.username, password: '', permission : user.permission });
    setEditId(user.id);
  };

  const handleDelete = async (id) => {
    if (window.confirm('Are you sure to delete this user?')) {
      await axios.delete(`/api/users/${id}`);
      fetchUsers();
    }
  };

  return (
    <Layout>
    <div className="container ">
    
<div className='login-wrap user-wrap mt-5'>  <h2>User Management</h2>
      <form onSubmit={handleSubmit} className="mb-4 user-form">
        <div className='row'>

        <div className='col-12 col-md-6'>
             <input name="name" placeholder="Name" className="form-control mb-2" value={formData.name} onChange={handleChange} tabIndex="1" />
             <input name="password" type="password" placeholder="Password" className="form-control mb-2" value={formData.password} onChange={handleChange} tabIndex="3"  />
         
        </div>
         <div className='col-12 col-md-6'>
        
             <input name="username" placeholder="Username" className="form-control mb-2" value={formData.username} onChange={handleChange} tabIndex="2"  />
 <div className="mb-3 radio-group">
          <label className="form-label d-block">Permission</label>
          <div className="form-check form-check-inline">
            <input
              className="form-check-input"
              type="radio"
              name="permission"
              value="view"
              checked={formData.permission === 'view'}
              onChange={() => setFormData({ name: formData.name, username: formData.username, password: formData.password , type:'employee', permission : 'view'})} tabIndex="4" 
            />
            <label className="form-check-label">View Only</label>
          </div>
          <div className="form-check form-check-inline">
            <input
              className="form-check-input" 
              type="radio"
              name="permission"
              value="download"
              checked={formData.permission === 'download'} tabIndex="5" 
              onChange={() => setFormData({ name: formData.name, username: formData.username, password: formData.password  , type:'employee', permission : 'download'})}
            />
            <label className="form-check-label">Download</label>
          </div>
        </div> 
        </div>
        </div>
        <button className="btn btn-primary" tabIndex="6" >{editId ? 'Update' : 'Add'} User</button>
      </form>
</div>
      <table className="table table-basic">
        <thead>
          <tr><th>Name</th><th>Username</th><th>Permission</th><th>Actions</th></tr>
        </thead>
        <tbody>
          {users.map((user, index) => (
            <tr key={user.id} className={index % 2 === 0 ? 'even' : 'odd'}>
              <td>{user.name}</td>
              <td>{user.username}</td>
              <td>{user.permission == "view" ? "View Only" : "Download"}</td>
              <td>
                <button className="btn btn-sm btn-warning me-2" onClick={() => handleEdit(user)}>Edit</button>
                <button className="btn btn-sm btn-danger" onClick={() => handleDelete(user.id)}>Delete</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
    </Layout>
  );
};

export default UserManagement;
